import classNames from "classnames";
import React from "react";

export type MessageType = "error" | "warning" | "info" | "success" | "accent";

interface Props {
  type: MessageType
  className?: string
  style?: React.CSSProperties
}

export const Message = (props: React.PropsWithChildren<Props>) => {
  return <div className={classNames("message-component", `message-component-${props.type}`, props.className)} style={props.style}>
    {props.children}
  </div>;
};
